<template>
    <a-drawer
      :title="'Incoming-'+actionName"
      placement="right"
      :closable="false"
      :visible="visible"
      @close="onClose"
      width="30%"
    >
        <div class="input-box">
            <p>姓名：</p>
            <a-input class="input" v-model="info.studentName" :disabled="actionName=='查看'"/>
        </div>
        <div class="input-box">
            <p>类别：</p>
            <a-select 
                class="input" 
                allowClear 
                show-search 
                :filter-option="filterOption"
                 v-model="info.incomingTypeCode"
                :disabled="actionName=='查看'">
                <a-select-option v-for="(item,index) in jxlbArr" :key="index" :value="item.dataCode">{{item.dataName}}</a-select-option>
            </a-select>
        </div>
        <div class="input-box">
            <p>派出高校：</p>
            <a-input class="input" :disabled="actionName=='查看'" v-model="info.dispatchedUniversity" />
        </div>
        <div class="input-box">
            <p>国籍：</p>
            <a-select 
                class="input" 
                allowClear 
                show-search 
                :filter-option="filterOption"
                 v-model="info.nationalityCode"
                :disabled="actionName=='查看'">
                <a-select-option v-for="(item,index) in gjArr" :key="index" :value="item.dataCode">{{item.dataName}}</a-select-option>
            </a-select>
        </div>
        <div class="input-box">
            <p>来华时间：</p>
            <a-date-picker class="input" v-model="info.comingDate" @change="(date, dateString)=>{info.comingDate=dateString}" :disabled="actionName=='查看'"/>
        </div>
        <div class="input-box">
            <p>离华时间：</p>
            <a-date-picker class="input" v-model="info.leavingDate" @change="(date, dateString)=>{info.leavingDate=dateString}" :disabled="actionName=='查看'"/>
        </div>
        <div class="btn-box">
            <a-button type="primary" @click="sub" v-if="actionName!='查看'">提交</a-button>
            <a-button @click="onClose">取消</a-button>
        </div>
    </a-drawer>
</template>

<script>
    import { getDicts } from '@/baseAPI/dictionary'
    import { add,update,info } from '@/baseAPI/international/incoming'
    export default {
        name: '',
        components: {
        },
        computed: {},
        data() {
            return {
                actionName:'',
                visible:false,
                id:'',
                info:{
                    studentName:null,
                    incomingTypeCode:null,
                    dispatchedUniversity:null,
                    nationalityCode:null,
                    comingDate:null,
                    leavingDate:null,
                },
                gjArr:[],
                jxlbArr:[],
            }
        },
        mounted () {
        },
        methods:{
            getInfo(){
                getDicts({dataCode:'GJ',status:true}).then(res=>{
                    this.gjArr=res.data.dicts;
                    this.info.nationalityCode=res.data.defaultValue[0]
                })
                getDicts({dataCode:'JXLB',status:true}).then(res=>{
                    this.jxlbArr=res.data.dicts;
                    this.info.incomingTypeCode=res.data.defaultValue[0]
                })
                if(this.actionName!='新增'){
                    info(this.id).then(res=>{
                        this.info=res.data;
                        this.teacherSearch(this.info.courseDirectorNo)
                    })
                }
            },
            showDrawer(name,id){
                this.id=id;
                this.actionName=name;
                this.getInfo();
                this.visible=true;
            },
            onClose() {
                this.info={
                    decideDate:null,
                    consProjectTypeCode:null,
                    projectLevelCode:null,
                    courseNo:null,
                    courseName:null,
                    courseAttrCode:null,
                    courseDirectorNo:null,
                    courseDirectorName:null,
                    remark:null
                };
                this.visible = false;
                this.$parent.fetch()
            },
            filterOption(input, option) {
                return (
                    option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
                );
            },
            sub(){
                var isSub=true;
                var arr=['remark','approvalStatus','courseAttrName']
                for(let key in this.info){
                    if(arr.indexOf(key)<0){
                        if(this.info[key]==null||this.info[key]===''){
                            isSub=false;
                            break;
                        }
                    }
                }
                if(isSub){
                    if(this.actionName=='新增'){
                        add(this.info).then(res=>{
                            if(res.data.success){
                                this.$notification['success']({
                                    message: '成功',
                                    description:'新增incoming成功',
                                });
                                this.onClose()
                            }else{
                                this.$notification['error']({
                                    message: '失败',
                                    description:res.data.errorMessage,
                                });
                            }
                        })
                    }else{
                        update(this.info).then(res=>{
                            if(res.data.success){
                                this.$notification['success']({
                                    message: '成功',
                                    description:'修改incoming成功',
                                });
                                this.onClose()
                            }else{
                                this.$notification['error']({
                                    message: '失败',
                                    description:res.data.errorMessage,
                                });
                            }
                        })
                    }
                }else{
                    this.$notification['warning']({
                        message: '警告',
                        description:'请填写完整！',
                    });
                }
            },

        }
    }
</script>

<style scoped>
    .ant-drawer >>> .ant-drawer-header{
        background-color: #245086;
        border-radius: 0;
    }
    .ant-drawer >>> .ant-drawer-title{
        color: #fff;
        font-weight: bold;
        letter-spacing: 1px;
        font-size: 1.1rem;
    }
    .input-box{
        display: flex;
        line-height: 32px;
        margin-bottom: 1.5rem;
        position: relative;
    }
    .input-box p{
        width: 8rem;
        text-align: right;
    }
    .input-box .input{
        width: calc(100% - 8rem);
    }
    .input-box .tips{
        width: calc(100% - 8rem);
        position: absolute;
        right: 0;
        top: 100%;
        font-size: 13px;
        line-height: 20px;
        color: #1890ff;
    }
    .btn-box{
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        text-align: right;
        padding-bottom: 1rem;
        background-color: #fff;
    }
    .btn-box .ant-btn{
        margin-right: 2rem;
    }
    .input>>>.ant-input[disabled],.ant-input[disabled],.ant-select-disabled,.ant-input-number-disabled{
        color: rgba(0, 0, 0, 0.65);
        background-color: transparent;
    }
    .ant-select-disabled >>> .ant-select-selection{
        background-color: transparent;
    }

</style>
